/** @jsxImportSource @emotion/react */
import moment from 'moment'

import { useAppSelector } from 'hooks/redux'
import { confirm } from 'components/molecules/Confirmation'
import { Note, PayerNotes } from 'store/types'

interface IProps {
  userContext: 'LAB' | 'DME'
  note?: Note
  payerNotes?: PayerNotes
  pinNote?: (param: { uuid: string; orderId: string; pinned: boolean }) => Promise<void>
  deleteNote?: (param: { uuid: string }) => Promise<void>
  editNote?: (note: Note) => void
  isEditable?: boolean
  orderId: string
}

const Box = ({
  userContext,
  note,
  pinNote,
  deleteNote,
  editNote,
  isEditable = false,
  payerNotes,
  orderId,
}: IProps) => {
  const profile = useAppSelector((state) => state.init.profile)
  const isAiConversationMemory = note?.source === 'aiConversationMemory'
  const callDirectionLabel = note?.callDirection
    ? `${note.callDirection.charAt(0).toUpperCase()}${note.callDirection.slice(1)}`
    : undefined
  const name = isAiConversationMemory
    ? `AI ${callDirectionLabel ? `${callDirectionLabel} ` : ''}Call Summary`
    : `${note?.userFirstName} ${note?.userLastName}`
  const timestamp = moment(note?.createdAt || payerNotes?.time).format('MM/DD/YYYY h:mm a')
  const pinClass = note?.pinned ? 'fas fa-star' : 'far fa-star'
  const isMyNote = profile?.email === note?.userEmail

  const pin = () => pinNote?.({ uuid: note?.uuid || '', orderId, pinned: !note?.pinned })
  const schedulingNoteFromLab = note?.type === 'scheduling' && userContext === 'DME'
  const canMutateNote = !note?.readOnly && !isAiConversationMemory

  return (
    <div className="note_box">
      <div className="note_box_meta">
        <div className="note_box_meta-user mb-1" style={{ color: note ? '#343a40' : '#4a89b3' }}>
          {note ? name : 'Insurance Notes'}
        </div>
        <div className="note_box_meta-date">
          <span>{timestamp}</span>
        </div>
      </div>
      <div
        className={`note_box_holder ${payerNotes ? 'payer' : ''} rounded ${note?.pinned ? 'note-pinned' : ''}`}
        css={{
          ...(schedulingNoteFromLab && { background: '#c6e3fa', border: 'none !important' }),
        }}>
        <p className="note_box_text pt-1 pl-1 font-italic" css={{ whiteSpace: 'pre-wrap' }}>
          {payerNotes?.notes || note?.text}
        </p>
        <div className={`actions ${payerNotes ? 'mb-2' : ''}`}>
          {pinNote && canMutateNote && (
            <span className={`pl-1 pb-1 note-star ${pinClass}`} onClick={pin}>
              <span className="note-star_text">{note?.pinned ? 'Pinned' : 'Pin Note'}</span>
            </span>
          )}
          {isEditable && userContext === 'LAB' && isMyNote && note && canMutateNote && (
            <span
              className="fas fa-pen pr-2 pb-1 ml-auto"
              style={{cursor: 'pointer'}}
              onClick={() => editNote?.(note)}
            />
          )}
          {deleteNote && userContext === 'LAB' && isMyNote && canMutateNote && (
            <span
              className={`note-trash fas fa-trash pr-1 pb-1 ${isEditable ? 'ml-0' : ''}`}
              onClick={() =>
                confirm('note')
                  .then(() => deleteNote({ uuid: note?.uuid || '' }))
                  .catch(() => {})
              }
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Box
